module.exports = __webpack_public_path__ + "img/4.5f1c4f14.jpg";